var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlashInCircle = function SvgSlashInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "slash-in-circle_svg__a",
    width: "105.8%",
    height: "102%",
    x: "-2.9%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "slash-in-circle_svg__b",
    d: "M0 0h800v2358H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-560H816v2626H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -356)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#slash-in-circle_svg__b",
    fill: "#000",
    filter: "url(#slash-in-circle_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#slash-in-circle_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 1C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m3.888 4.091a.5.5 0 0 1 .364.606L15.678 9H17.5a.5.5 0 1 1 0 1h-2.072l-.997 4H17.5a.5.5 0 1 1 0 1h-3.318l-.59 2.37a.5.5 0 0 1-.971-.241l.53-2.129H9.682l-.59 2.37a.5.5 0 0 1-.971-.241L8.651 15H6.5a.5.5 0 1 1 0-1h2.4l.998-4H6.5a.5.5 0 0 1 0-1h3.647l.635-2.545a.5.5 0 1 1 .97.242L11.178 9h3.469l.635-2.545a.5.5 0 0 1 .606-.364M13.4 14l.998-4h-3.47l-.997 4z"
  }))));
};
export default SvgSlashInCircle;